export const SET_MONTHLY_FORM_SUCCESS = 'set-monthly-form-success';
const setMonthlyFormSuccess = () => ({ type: SET_MONTHLY_FORM_SUCCESS });
export default setMonthlyFormSuccess;
